export const formatRole = (role?: string): string =>
  (role ?? '')
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export const getInitials = (
  firstName?: string,
  lastName?: string,
  fallback?: string,
): string => {
  const initials = [firstName, lastName]
    .map((part) => part?.trim().charAt(0) ?? '')
    .join('');
  return (initials || fallback?.trim().charAt(0) || '').toUpperCase();
};
